import * as D from '@/domain'
import * as React from 'react'
import { useBallotContext } from '../contexts'
import { useEnv } from '../lib'
import { commonDescriptors } from '../locale/messages'
import * as F from 'fp-ts'

interface Props {
  outcome: D.Outcome
}

/**
 * This component renders just the tiebreak label text, no DOM Elements. It respects
 * the custom side labels defined in the BallotDocumentBase (which is provided
 * through the BallotContext).
 */
export const TiebreakLabelText = React.memo<Props>(({ outcome }) => {
  const { intl } = useEnv()
  const { ballotDocumentBase } = useBallotContext()

  return F.function.pipe(
    F.option.fromNullable(ballotDocumentBase.sideLabels),
    F.option.chain((sideLabels) => F.option.fromNullable(sideLabels[outcome])),
    F.option.chain((mls) => F.option.fromNullable(D.pickMultiLocaleString(intl, mls, undefined))),
    F.option.fold(
      () => <>{intl.formatMessage(commonDescriptors.tiebreakLabel, { outcome })}</>,
      (str) => <>{str}</>,
    ),
  )
})
